<template>
    <div>
      <div style="position: relative;bottom: 0px;width: 100%">
        <footer class="py-5 bg-dark" style="height: 150px;">
          <div class="container">
            <p class="m-0 text-center text-white">Copyright &copy; 安徽华源医药电子商务 2019</p>
          </div>
          <!-- /.container -->
        </footer>

      </div>

    </div>

</template>
<script>
export default {
     name:'m-footer',
     data () {
       return {}
     },
  mounted: function () {
    window.addEventListener('scroll',this.getScrollPosition,false)
  },destroyed: function () {
    window.removeEventListener('scroll',this.getScrollPosition,false)
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue